/**
 * Usage Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/usage
 */

const EVENT_TYPES = ['api_call', 'storage_gb_hour', 'bandwidth_gb', 'compute_hour', 'mail_sent'];

export function usageFixture({ userId = '', eventType = '', from, to } = {}) {
  const now = Date.now();
  const startMs = from ? new Date(from).getTime() : now - 30 * 86_400_000;
  const endMs = to ? new Date(to).getTime() : now;
  const days = Math.max(1, Math.floor((endMs - startMs) / 86_400_000));

  const all = [];
  for (let d = 0; d < days; d += 1) {
    const dayMs = startMs + d * 86_400_000;
    EVENT_TYPES.forEach((type, ti) => {
      const base = (type === 'api_call' ? 5000 : type === 'storage_gb_hour' ? 250 : type === 'bandwidth_gb' ? 80 : type === 'compute_hour' ? 24 : 40);
      const count = Math.round(base * (1 + 0.2 * Math.sin(d * 0.3 + ti)));
      all.push({
        userId: 4700 + ((d + ti) % 25),
        eventType: type,
        count,
        unit: type === 'api_call' ? 'calls' : type === 'storage_gb_hour' ? 'GB·h' : type === 'bandwidth_gb' ? 'GB' : type === 'compute_hour' ? 'h' : 'mails',
        at: new Date(dayMs + ti * 3_600_000).toISOString(),
      });
    });
  }

  const filtered = all.filter((e) => {
    if (userId && String(e.userId) !== String(userId)) return false;
    if (eventType && e.eventType !== eventType) return false;
    return true;
  });

  // Aggregate per type
  const byType = {};
  filtered.forEach((e) => {
    if (!byType[e.eventType]) byType[e.eventType] = { total: 0, unit: e.unit, perDay: {} };
    byType[e.eventType].total += e.count;
    const day = e.at.slice(0, 10);
    byType[e.eventType].perDay[day] = (byType[e.eventType].perDay[day] || 0) + e.count;
  });

  return {
    events: filtered.slice(0, 200),
    aggregate: {
      total: filtered.length,
      byEventType: byType,
    },
    knownEventTypes: EVENT_TYPES,
  };
}
